import React from 'react';
import { Neo, Views, NeoGrid } from '@singularsystems/neo-react';
import InstrumentMappingVM from './InstrumentMappingVM';
import { observer } from 'mobx-react';
import InstrumentMappingsLookup from '../Models/InstrumentMappingLookupModel';
import RunInterceptionComponent from '../../../Common/Components/Interception/RunInterceptionComponent';
import { TextConstants } from '../../../Common/TextConstants';
import AssignInstrumentComponent from '../components/AssignInstrumentComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { InstrumentMapping } from '../../../AccessControl/Models/Commands/Security/Roles';
import { InterceptionProcessEnum } from '../../../Common/Enums/InterceptionProcessEnum';

@observer
export default class InstrumentMappingView extends Views.ViewBase<InstrumentMappingVM> {
    constructor(props: unknown) {
        super("Instrument Mapping", InstrumentMappingVM, props);
    }

    public render() {
        return (
            <div>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showAssignInstrumentComponent &&
                    <AssignInstrumentComponent
                        viewModel={this.viewModel.assignInstrumentVM}
                        instrumentMappingUpdateList={this.viewModel.instrumentMappingUpdateList}
                        onBack={() => this.viewModel.backToInstrumentMapping()}
                        onSave={() => this.viewModel.updateInstrumentMapping()}
                        onInstrumentSearch={() => this.viewModel.onAssignInstrumentSearch()}
                    />}
                {this.viewModel.showAssignInstrumentComponent === false &&
                    <>
                        <Neo.Card title={TextConstants.Titles.InstrumentMapping} className="m-1">
                            <Neo.Form onSubmit={() => this.viewModel.instrumentMappingCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <Neo.FormGroup className="form-search" bind={this.viewModel.instrumentMappingCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchInstrumentMapping}
                                    suppressLabel={true}
                                    append={<Neo.Button isSubmit>
                                        <i className={`${this.viewModel.instrumentMappingCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                    </Neo.Button>} />
                            </Neo.Form>
                            <div className="row text-left">
                                {this.viewModel.authorisationService.hasRole(InstrumentMapping.Select) &&
                                    <div className="col-lg-2">
                                        <div className="btn-inline pb-3 pt-0">
                                            <Neo.Button variant="primary"
                                                disabled={this.viewModel.instrumentMappingUpdateList.length === 0}
                                                onClick={() => this.viewModel.displayAssignInstrumentComponent()}>
                                                {TextConstants.Buttons.MapInstrument}
                                            </Neo.Button>
                                        </div>
                                    </div>
                                }
                            </div>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <NeoGrid.Grid<InstrumentMappingsLookup> className={"table-striped"}>
                                    {(data, meta) => (
                                        <NeoGrid.Row>
                                            {this.viewModel.authorisationService.hasRole(InstrumentMapping.Select) &&
                                                <NeoGrid.Column bind={meta.select} type="check" onChange={(event) => this.viewModel.populateMappedObject(data)} label={TextConstants.Labels.Select} />
                                            }
                                            <NeoGrid.Column display={meta.stockbroker} label={TextConstants.Labels.Broker} />
                                            <NeoGrid.Column display={meta.staticInstrument} sort={false} label={TextConstants.Labels.AssignedInstrument} />
                                            <NeoGrid.Column display={meta.instrumentCode} />
                                            <NeoGrid.Column display={meta.description} label={TextConstants.Labels.InstrumentDescription} />
                                            <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                                            <NeoGrid.Column display={meta.instrumentType} />
                                            <NeoGrid.Column display={meta.instrumentSubType} />
                                            <NeoGrid.Column display={meta.exchange} label={TextConstants.Labels.InstrumentExchange} />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>
                        </Neo.Card>

                        {this.viewModel.authorisationService.hasRole(InstrumentMapping.RunInterception) &&
                            <RunInterceptionComponent
                                viewModel={this.viewModel.runInterceptionVM}
                                interceptionStoredProcedure={InterceptionProcessEnum.Instrument}/>}
                    </>
                }
            </div>
        );
    }
}